import type { ChatMessage } from "../../model";
import "./ai-chat-content.scss";
import { AiChatAvatar } from "./ui/avatar";
import { AiChatMessage } from "./ui/message";

export const AiChatContent = ({ messages }: { messages: ChatMessage[] }) => {
  return (
    <div
      className="ai-chat-content"
      onWheelCapture={(e) => {
        // Не даём родителям перехватывать wheel (sticky/страница),
        // иначе скролл внутри чата может "не работать" на трекпаде.
        e.stopPropagation();
      }}
      onTouchMoveCapture={(e) => {
        e.stopPropagation();
      }}
    >
      <div className="ai-chat-content__wrapper">
        <div className="ai-chat-content__avatar-container">
          <AiChatAvatar />
        </div>
        <div className="ai-chat-content__messages">
          {messages.map((message) => (
            <AiChatMessage key={message.id} message={message} />
          ))}
        </div>
      </div>
    </div>
  );
};
